/* eslint max-classes-per-file: 0 */

import {
  BaseApiParams as BP,
  BaseApiResponse as BR,
} from '@/typings/common'
import {
  PublicationStorageFile as Data,
  PublicationStorageFileCollection as Collection,
} from '@/typings/api/Publication'
import { PublicationsStorageFilesApi as Api } from '@/api/resources'

import { Fabric } from '@/store/createCrudModule'


const { TransformerParams, TransformerData, Adapter } = Fabric<Data, Collection>()

export class PublicationStorageFilesTransformerParams extends TransformerParams {
  protected defaultParams = ['publication_id', 'storage_id'];

  protected delete_multiple_param = 'storage_file_ids';
}

export class PublicationStorageFilesTransformerData extends TransformerData {
  public create<R extends BR<Data | void> = BR<Data | void>, P = BP>(response: R, params: P) {
    const result = this.toTransform<R, P>(response, params)
    // @ts-ignore TODO:
    const id = result.data.result[0] as number
    return { data: { id } } as unknown as R
  }
}

export class PublicationsStorageFilesAdapter extends Adapter<Api> {
  public readonly api = new Api();

  public readonly transformerParams = new PublicationStorageFilesTransformerParams();

  public readonly transformerData = new PublicationStorageFilesTransformerData();
}
